import React, { useEffect, useState } from 'react';
import { Card, Table, Pagination, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer, { initialState } from './reducer';
import saga from './saga';
import _ from 'lodash';
import ConfirmModal from 'components/ConfirmModal';
import { listHowto, toggleDrawer } from './action';
import AddHowtoDrawer from 'components/AddHowtoDrawer';
import { HowtoTableConfig } from './HowtoTableConfig';

function Howto() {
  useInjectReducer({ key: 'howto', reducer });
  useInjectSaga({ key: 'howto', saga });
  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [searchedColumn, setSearchedColumn] = useState(null);
  const [deleteModalToggle, setDeleteModalToggle] = useState(false);
  const [selectedHowto, setselectedHowto] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const howtoState = useSelector((state) => state.howto || initialState);
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  useEffect(() => {
    const columns = HowtoTableConfig(
      handleSearch,
      handleReset,
      // onDelete,
      editUserHowto,
      authState.userResponsibilities,
    );
    setColumns(columns);
    dispatch(listHowto({ page: 1, limit: 10 }));
  }, []);

  // const onDelete = (item) => {
  //   if (!_.isNil(item)) {
  //     setselectedHowto(item);
  //     dispatch(toggleDeleteModal());
  //     return;
  // };
  // dispatch(deleteQuote(selectedHowto.quote_id));
  // console.log(item);
  // }
  const resetPagination = () => setCurrentPage(1);

  const editUserHowto = (message) => {
    setselectedHowto(message);
    dispatch(toggleDrawer());
  };

  const onPageChange = (page, pageSize) => {
    let filter = { page, limit: pageSize };
    setCurrentPage(page);
    if ((searchedColumn, searchText)) {
      filter = { ...filter, [searchedColumn]: searchText };
    }
    dispatch(listHowto(filter));
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length <= 0) {
      message.error('Please select to search');
      return;
    }
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    dispatch(listHowto({ page: 1, limit: 10, [dataIndex]: selectedKeys[0] }));
    resetPagination();
  };
  // const handleDeleteModalToggle = () => dispatch(toggleDeleteModal());

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText(null);
    setSearchedColumn(null);
    dispatch(listHowto({ page: 1, limit: 10 }));
    resetPagination();
  };
  return (
    <>
      <Card
        title="How To's"
        extra={
          <AddHowtoDrawer
            initialState={initialState}
            selectedHowto={selectedHowto}
            resetPagination={resetPagination}
            editUserHowto={editUserHowto}
            roleAddResponsibility={_.includes(
              authState.userResponsibilities,
              'ADD_HOWTO_BUTTON',
            )}
          />
        }
      >
        <Table
          columns={columns}
          loading={howtoState.loading}
          bordered
          pagination={false}
          size={'small'}
          dataSource={howtoState.data}
          style={{ height: '70vh', overflow: 'scroll' }}
        />
        <Pagination
          style={{ marginTop: '10px' }}
          total={howtoState.totalCount}
          showTotal={(total) => `Total ${total} items`}
          defaultPageSize={10}
          current={currentPage}
          showLessItems={true}
          showSizeChanger={false}
          disabled={howtoState.loading}
          onChange={onPageChange}
        />
      </Card>
      {/* <ConfirmModal
        title={'Delete Quote Confirmation'}
        text={'Are you sure you want to delete this quote ?'}
        toggle={howtoState.deleteModal}
        loading={howtoState.loading}
        handleDeleteModalToggle={handleDeleteModalToggle}
        onDelete={onDelete}
      /> */}
    </>
  );
}

export default Howto;
